import React from 'react';
import Chip, { ChipProps } from '@mui/material/Chip';
import { alpha, PaletteColor, useTheme } from '@mui/material/styles';
import { surface } from 'modules/minimal-ui-theme';

interface Props extends ChipProps {}

export type BoldChipColors =
  | 'info'
  | 'success'
  | 'primary'
  | 'warning'
  | 'error'
  | 'neutral';

export const BoldChip: React.FC<Props> = props => {
  const theme = useTheme();

  const colorMap: Record<BoldChipColors, PaletteColor> = {
    info: theme.palette.info,
    success: theme.palette.success,
    primary: theme.palette.primary,
    warning: theme.palette.warning,
    neutral: theme.palette.neutral,
    error: theme.palette.error
  };

  const color = props.color
    ? colorMap[props.color as BoldChipColors].main
    : theme.palette.primary.main;

  // Solid Figma surfaces for the warning ("in review") and success ("active"/"closed")
  // states; the remaining states keep the translucent fill.
  const surfaceMap: Partial<
    Record<BoldChipColors, { bg: string; text: string }>
  > = {
    warning: surface.warning,
    success: surface.success
  };
  const tone = props.color
    ? surfaceMap[props.color as BoldChipColors]
    : undefined;

  const modifiedProps: ChipProps = {
    ...props,
    sx: {
      ...(props.sx ?? {}),
      fontWeight: 600,
      backgroundColor: tone ? tone.bg : alpha(color, 0.32),
      ...(tone && { color: tone.text }),
      cursor: 'default',
      height: 28
    }
  };

  return <Chip {...modifiedProps} />;
};
